import Image from 'next/image'

import { Roster } from '@ui/article/Roster'

import {
  Content,
  ContentWrapper,
  OrangeHexagon,
  Subtitle,
  Title,
  TitleWrapper,
  Wrapper,
} from './styles'

export function TableSection({
  config,
  marginTop = '126px',
  spacing = '32px',
  contentWidth = '308px',
  contentWidthMobile = '308px',
  hexagon = true,
  noTitleTransform = false,
}) {
  return (
    <Wrapper marginTop={marginTop} className="table-wrapper">
      <ContentWrapper spacing={spacing}>
        {config.map(({ id, title, subtitle, alt, roster, mobileFont }) => (
          <Content
            contentWidthMobile={contentWidthMobile}
            contentWidth={contentWidth}
            key={id}
            className="content"
          >
            <TitleWrapper>
              <Image
                key={id}
                alt={alt || ''}
                src="/images/cases/table-section-hexagon.svg"
                width={37}
                height={43}
                quality={90}
              />
              <Title as="h2" noTextTransform={noTitleTransform}>
                {title}
              </Title>
            </TitleWrapper>
            <Subtitle as={roster && 'span'} mobileFont={mobileFont}>
              {roster && <Roster marginTop="0px" config={roster} />}
              {subtitle}
            </Subtitle>
          </Content>
        ))}
      </ContentWrapper>
      {hexagon && <OrangeHexagon />}
    </Wrapper>
  )
}
